import _toConsumableArray from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
// import YYImage from '@/components/basic/image'
// import yyicon from '@/components/basic/icon'
// import YYBadge from '@/components/basic/badge'
// import YYInput from '@/components/basic/input'
// import YYButton from '@/components/basic/button'
// import { languages as allLangList } from '@/locales/'
// import { updateCustomerLanguage } from '@/api/header'
// import YYMessage from '@/components/basic/message'
// import { quit } from '@/api/account'
import { mapState } from 'vuex';
import clickoutside from '@/pages/design/directives/clickoutside';
import MenuCategory from "@/pages/design/components/MenuCategory";
import i18n from '@/pages/design/locales';
export default {
  name: 'Menubar',
  props: {
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  directives: {
    clickoutside: clickoutside
  },
  components: {
    // YYBadge,
    // YYInput,
    // YYButton,
    // YYMessage,
    // YYImage
    MenuCategory: MenuCategory
  },
  data: function data() {
    return {
      navigationTextColor: '',
      navigationBgColor: '',
      logo: '',
      token: '',
      navigationstatus: false,
      //导航菜单是否显示更多
      searchDialogStatus: true,
      searchHistoryList: [],
      //热词列表
      hotWordList: [],
      //语言列表
      languages: [],
      languageName: '',
      //导航栏
      navigations: [],
      //全部分类显示开关
      all_categories_visible: false,
      //头部吸顶
      top_visible: false,
      //选择多语言
      languages_visible: false,
      //用户菜单
      user_menu_visible: false,
      //搜索框是否显示
      text_search_visible: false,
      //搜索内容
      text_search: '',
      //更多导航菜单弹窗
      more_visible: false,
      noticeShowStatus: false,
      //公共是否显示状态
      //获取焦点
      focus: false,
      categoriesTop: 138,
      categoriesCanScroll: false,
      categoriesShowFlag: 0,
      //0：导航没有吸顶展开  1：导航吸顶后展开
      offsetHideDistance: 400,
      //吸顶状态下，分类区域隐藏偏移量
      afterArr: [],
      // menu 剩余的部分
      menuArr: this.formData.titles,
      //所有的menu,
      isShowMoreLabel: false,
      // 是否显示more的label
      max: 0,
      defaultLangId: 0,
      isShowMenuCategory: false,
      i18n: i18n
    };
  },
  watch: {
    token: function token(newName, oldName) {
      if (newName != oldName) {
        this.getCartProductNum();
      }
    },
    focus: function focus(newValue, oldValue) {
      var _this = this;
      if (newValue) {
        document.onkeypress = function (e) {
          if (e.keyCode == 13) {
            _this.search(_this.text_search);
            _this.$router.push({
              name: 'productlist',
              query: {
                search: _this.text_search,
                orderType: 1,
                page: 1
              }
            }).then(function () {
              //清除onkeypress事件，输入框失去焦点
              document.onkeypress = null;
              _this.focus = false;
            });
          }
        };
      }
    }
  },
  created: function created() {
    // let defaultLangObj = JSON.parse(localStorage.defaultLangObj)
    var defaultLangObjStr = window.localStorage.cdefaultLangObj ? window.localStorage.cdefaultLangObj : window.localStorage.defaultLangObj;
    var defaultLangObj = JSON.parse(defaultLangObjStr);
    if (defaultLangObj) {
      this.defaultLangId = defaultLangObj.langId;
    }
    var lang = localStorage.langCode;
    this.i18n.locale = lang;
    this.$t = this.i18n.t.bind(this.i18n);
  },
  mounted: function mounted() {
    var _this2 = this;
    // console.log('mounted header.vue')
    // if (window.localStorage.getItem('searchHistoryList')) {
    //   //searchHistoryList有值才执行接下来的操作
    //   this.searchHistoryList = JSON.parse(
    //     window.localStorage.getItem('searchHistoryList')
    //   )
    // }

    // window.document.addEventListener('click', this.handleDocumentClick)
    // window.document.addEventListener('touchstart', this.handleDocumentClick)
    // window.document.addEventListener('scroll', this.handleScrollHandler)
    /* window.addEventListener('resize', this.handleResizeHandler); */

    // this.fetchData().then(this.loadData)

    setTimeout(function () {
      _this2.computeItem();
    }, 300);

    // 不能使用updated监听...会导致页面陷入循环 卡死
    // 当titles数组改变了 就重新计算宽度
    this.$watch("formData.titles", function (old, val) {
      this.beforeArr = val;
      this.computeItem();
    }, {
      deep: true
    });
    this.$watch("formData.categoryStatus", function () {
      var _this3 = this;
      // 为了避免dom没有生成, 计算了错误的宽度  所以用了setTimeout
      setTimeout(function () {
        _this3.computeItem();
      }, 0);
    });
    this.$watch("formData.fontSize", function () {
      var _this4 = this;
      // 为了避免dom没有生成, 计算了错误的宽度  所以用了setTimeout
      setTimeout(function () {
        _this4.computeItem();
      }, 0);
    });
    this.$watch("formData.titleSpace", function () {
      var _this5 = this;
      // 为了避免dom没有生成, 计算了错误的宽度  所以用了setTimeout
      setTimeout(function () {
        _this5.computeItem();
      }, 0);
    });
    //formData.categoryTitle
    this.$watch("formData.categoryTitle", function () {
      var _this6 = this;
      // 为了避免dom没有生成, 计算了错误的宽度  所以用了setTimeout
      // setTimeout(() => {
      //   this.computeItem();
      // }, 0);
      this.$nextTick(function () {
        _this6.computeItem();
      });
    }, {
      deep: true
    });
  },
  computed: _objectSpread(_objectSpread({}, mapState(['headerData', 'shopcartNum', 'designPublicData', 'designImgHost'])), {}, {
    beforeArr: {
      get: function get() {
        return this.menuArr;
      },
      set: function set(val) {
        this.menuArr = val;
      }
    }
  }),
  // serverPrefetch() {
  //   return this.fetchData().then(this.loadData)
  // },
  beforeDestroy: function beforeDestroy() {
    // window.document.removeEventListener('click', this.handleDocumentClick)
    // window.document.removeEventListener('touchstart', this.handleDocumentClick)
    // window.document.removeEventListener('scroll', this.handleScrollHandler)
    /* window.removeEventListener('resize', this.handleResizeHandler); */
  },
  methods: {
    computeItem: function computeItem() {
      var width = 0;

      // 获取宽度
      function getWidth(el, column) {
        var reg = /(\d+)/;
        var widthStr = document.defaultView.getComputedStyle(el, null)[column];
        var width = Number(reg.exec(widthStr)[0]);
        return width;
      }
      var ele = document.querySelector('.hm-menubar-x');

      // // 获取所有的menubar 菜单
      var menubarItems = document.querySelectorAll('.navitems_content > dd > dl');

      // // 获取所有折叠中的菜单
      var menubarDialogItems = document.querySelectorAll('.more-item');

      // ele.children
      // let itemList = this.formData.categoryStatus ? [ele.firstChild,...menubarItems, ...menubarDialogItems]:[...menubarItems, ...menubarDialogItems]

      var itemList = [].concat(_toConsumableArray(menubarItems), _toConsumableArray(menubarDialogItems));
      var w = getWidth(menubarItems[0], 'margin-right');
      var elmore = document.querySelector('.more_label');
      var titles = this.formData.titles;

      // 计算宽度和margin-right的总和
      for (var index = 0; index < itemList.length; index++) {
        var el = itemList[index];
        width += w + el.clientWidth;
        if (width > 1200 - (elmore.clientWidth + w)) {
          this.max = index;
          if (this.formData.categoryStatus) {
            this.beforeArr = titles.slice(0, this.max - 1);
            this.afterArr = titles.slice(this.max - 1);
          } else {
            this.beforeArr = titles.slice(0, this.max);
            this.afterArr = titles.slice(this.max);
          }
          this.isShowMoreLabel = true;
          break;
        } else {
          this.beforeArr = titles;
          this.afterArr = [];
          this.isShowMoreLabel = false;
          // this.max = 0;
          // if (this.isShowMoreLabel) {
          //   this.isShowMoreLabel = false;
          // }
        }
      }

      // 如果剩余数组没有数据 就不显示more按钮了

      if (this.afterArr.length == 0) {
        this.isShowMoreLabel = false;
      }
    },
    handleScrollHandler: function handleScrollHandler(e) {
      var scrollTop = document.documentElement.scrollTop;
      this.top_visible = scrollTop > this.$el.offsetHeight;
      var all_categories = document.querySelector('.all_categories');
      var isVisbile = this.checkVisible(all_categories);
      //如果分类区域不可见，隐藏分类
      if (!isVisbile) {
        this.all_categories_visible = false;
      }
      //如果导航吸顶的情况下，滚动条位置小于显示分类时的位置，说明是向上滚动了滚动条，将分类区域固定显示，否则可以滚动
      if (this.top_visible) {
        var navigatorBottom = 0;
        if (document.querySelector('.top .header_top')) {
          var _navigatorBottom = document.querySelector('.top .header_top').getBoundingClientRect().bottom;
          if (this.noticeShowStatus) {
            var noticeBottom = document.querySelector('.affiche').getBoundingClientRect().bottom;
            var noticeTop = document.querySelector('.affiche').getBoundingClientRect().top;
            _navigatorBottom = _navigatorBottom - (noticeBottom - noticeTop);
          }
        }
        if (scrollTop + navigatorBottom < this.categoriesTop) {
          var _scrollTop = document.documentElement.scrollTop;
          // console.log("到达时的位置",scrollTop)
          if (this.categoriesShowFlag == 1) {
            console.log('客户与本：', this.categoriesTop - (_scrollTop + navigatorBottom) - this.offsetHideDistance);
            if (this.categoriesTop - (_scrollTop + navigatorBottom) - this.offsetHideDistance > 0) {
              this.all_categories_visible = false;
            } else {
              this.categoriesCanScroll = true;
            }
          }
        } else if (this.categoriesShowFlag == 1) {
          this.categoriesCanScroll = false;
        }
      } else {
        this.categoriesCanScroll = false;
        this.categoriesTop = 138;
      }
    },
    showHideCategories: function showHideCategories() {
      var scrollTop = document.documentElement.scrollTop;
      if (this.top_visible) {
        this.categoriesShowFlag = 1;
      } else {
        this.categoriesShowFlag = 0;
      }
      //导航是隐藏状态时，显示分类时，将分类区域位置设置为滚动条位置；如果导航是显示状态，分类区域固定在138的位置
      if (!this.all_categories_visible) {
        if (this.top_visible) {
          var navigatorBottom = document.querySelector('.top .header_top').getBoundingClientRect().bottom;
          if (this.noticeShowStatus) {
            var noticeBottom = document.querySelector('.affiche').getBoundingClientRect().bottom;
            var noticeTop = document.querySelector('.affiche').getBoundingClientRect().top;
            navigatorBottom = navigatorBottom - (noticeBottom - noticeTop);
          }
          this.categoriesTop = document.documentElement.scrollTop + navigatorBottom;
        } else {
          this.categoriesTop = 138;
        }
      }
      this.all_categories_visible = !this.all_categories_visible;
    },
    checkVisible: function checkVisible(elm) {
      if (!elm) {
        return;
      }
      var rect = elm.getBoundingClientRect();
      //获取当前浏览器的视口高度，不包括工具栏和滚动条
      //document.documentElement.clientHeight兼容 Internet Explorer 8、7、6、5
      var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
      //bottom top是相对于视口的左上角位置
      //bottom大于0或者top-视口高度小于0可见
      return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
    },
    setTextSearch: function setTextSearch(content) {
      this.text_search = content;
    },
    clickIconUser: function clickIconUser() {
      // if (window.localStorage.token) {
      //   this.user_menu_visible = !this.user_menu_visible
      // } else {
      //   //点击登录成功后，重定向到我的订单
      //   this.$router.push({
      //     name: 'login',
      //     query: { redirect: '/account/order' }
      //   })
      //   // this.$router.push({ path: '/account/order'})
      // }
    },
    searchInputFocus: function searchInputFocus() {
      // this.focus = true
      // let self = this
      // if (!self.text_search) {
      //   self.$nextTick(() => {
      //     self.searchDialogStatus = true
      //   })
      // }
    },
    //去重方法封装
    unique: function unique(arr) {
      return arr.filter(function (item, index, arr) {
        return arr.indexOf(item, 0) === index;
      });
    },
    closeNotice: function closeNotice() {
      // // this.$refs.affiche.style.display = 'none';
      // this.noticeShowStatus = false
      // window.localStorage.noticeShowStatus = false
    },
    //搜索
    search: function search(keyword) {
      // this.focus = false
      // this.searchDialogStatus = false
      // if (keyword.trim() !== '') {
      //   this.searchHistoryList.unshift(keyword)
      //   this.searchHistoryList = this.unique(this.searchHistoryList) //调用unique方法去重
      //   if (this.searchHistoryList.length > 8) {
      //     //最多保存8条
      //     this.searchHistoryList = this.searchHistoryList.slice(0, 8)
      //   }
      //   window.localStorage.setItem(
      //     'searchHistoryList',
      //     JSON.stringify(this.searchHistoryList)
      //   ) //存localStorage
      //   this.text_search = keyword.trim()
      // }
    },
    //点击搜索按钮
    clickSearchBtn: function clickSearchBtn() {
      // let self = this
      // self.text_search_visible = true
      // self.$nextTick(() => {
      //   self.$refs.search.focus()
      // })
    },
    //删除搜索列表记录
    deleteSearchHistoryList: function deleteSearchHistoryList() {
      // window.localStorage.removeItem('searchHistoryList')
      // this.searchHistoryList = []
    },
    //单个删除搜索记录
    deleteSearchHistory: function deleteSearchHistory(index) {
      // let self = this
      // self.searchHistoryList.splice(index, 1)
      // window.localStorage.setItem(
      //   'searchHistoryList',
      //   JSON.stringify(self.searchHistoryList)
      // ) //存localStorage
    },
    fetchData: function fetchData() {
      // let data = this.$store.dispatch('FETCH_HEADERDATA')
      // return data
    },
    loadData: function loadData() {
      // let self = this
      // console.log(' this.headerData', this.headerData)
      // let data = this.headerData.headerInfo //头部信息

      // console.log('首赠logo', data.host, data.logo)
      // this.$nextTick(() => {
      //   self.logo = data.host + data.logo
      // })
      // // if (!data) {
      // //   return
      // // }
      // if (this.headerData.headerInfo.zz0005) {
      //   console.log('加载谷歌统计')
      //   window.dataLayer = window.dataLayer || []

      //   window.gtag = function () {
      //     window.dataLayer.push(arguments)
      //   }

      //   window.gtag('js', new Date())

      //   window.gtag('config', process.env.config.googleKey)

      //   console.log('执行谷歌统计', this.$route.path)
      //   window.gtag('config', process.env.config.googleKey, {
      //     page_path: this.$route.path
      //   })
      // }

      // self.$store.state.leftCurrencySymbol = data.leftSymbol
      // self.$store.state.rightCurrencySymbol = data.rightSymbol
      // window.localStorage.setItem('storeName', data.storeName)

      // if (this.noticeInfo) {
      //   if (!window.localStorage.noticeLastUpdateTime) {
      //     window.localStorage.setItem(
      //       'noticeLastUpdateTime',
      //       this.noticeInfo.value.updateTime
      //     )
      //     self.noticeShowStatus = true
      //     window.localStorage.setItem('noticeShowStatus', true)
      //   } else {
      //     // console.log('this.noticeInfo.value.updateTime', this.noticeInfo.value.updateTime	)
      //     if (
      //       window.localStorage.noticeLastUpdateTime !=
      //         this.noticeInfo.value.updateTime ||
      //       window.localStorage.noticeShowStatus == 'true'
      //     ) {
      //       self.noticeShowStatus = true
      //       window.localStorage.setItem('noticeShowStatus', true)
      //     }
      //   }
      // }

      // if (data.navigatorInfo.length > 10) {
      //   self.navigationstatus = true
      // }

      // for (let item of data.langList) {
      //   item.value = allLangList[item.langId]
      //   if (window.localStorage.languageCode == item.value) {
      //     self.languageName = item.langTitle
      //   }
      // }

      // self.languages = data.langList
      // self.navigationBgColor = data.navigatorCss.bgColor
      // self.navigationTextColor = data.navigatorCss.textColor
      // self.ico = data.host + data.ico
      // //修改网页标题左侧ico
      // //有可能到这里的时候，window.onload的回调已经执行完毕了
      // if (document.getElementsByTagName('head')) {
      //   var link =
      //     document.querySelector("link[rel*='icon']") ||
      //     document.createElement('link')
      //   link.type = 'image/x-icon'
      //   link.rel = 'shortcut icon'
      //   link.href = data.host + data.ico + '?num=' + Math.random()
      //   document.getElementsByTagName('head')[0].appendChild(link)
      // } else {
      //   window.onload = function () {
      //     var link =
      //       document.querySelector("link[rel*='icon']") ||
      //       document.createElement('link')
      //     link.type = 'image/x-icon'
      //     link.rel = 'shortcut icon'
      //     link.href = data.host + data.ico + '?num=' + Math.random()
      //     document.getElementsByTagName('head')[0].appendChild(link)
      //   }
      // }
    },
    //选择语言
    languageChang: function languageChang(item) {
      var _this7 = this;
      //更新客户表语言id
      updateCustomerLanguage(window.localStorage.langId).then(function (res) {
        if (res.data.code == 200) {
          // loadLanguageAsync(item.value)
          _this7.languageName = item.langTitle;
          _this7.$store.commit('SET_LANG', {
            lang: item.value
          });
          // window.localStorage.langId = item.langId;
          // window.localStorage.languageCode = item.value;
        }
      });
    },
    handleDocumentClick: function handleDocumentClick(e) {
      var self = this;
      //全部分类
      if (!this.$refs.all_categories.contains(e.target) && !this.$refs.all_product.contains(e.target) && !this.$refs.all_product2.contains(e.target)) {
        this.all_categories_visible = false;
      }
      //多语言
      if (!this.$refs.languages.contains(e.target)) {
        this.languages_visible = false;
      }
      //用户
      if (!this.$refs.user_menu.contains(e.target)) {
        this.user_menu_visible = false;
      }
      //搜索弹窗
      if (!self.$refs.search_box.contains(e.target) && !self.$refs.search_icon.contains(e.target)) {
        self.searchDialogStatus = false;
      }

      //更多导航菜单
      if (this.$refs.moreNavigations && !this.$refs.moreNavigations.contains(e.target)) {
        this.more_visible = false;
      }
    },
    //退出
    quit: function quit() {
      // quit().then((res) => {
      //   if (res.data.code == 200) {
      //     window.localStorage.removeItem('token')
      //     window.localStorage.removeItem('nickName')
      //     this.$store.state.token = ''
      //     YYMessage(this.$t('memberCenter.logoutSuccess'))
      //     this.$store.commit('updateShopcartNum', { shopcartNum: 0 })
      //     this.$router.push({ path: '/' })
      //   }
      // })
    } //监听浏览器宽度 修改导航菜单是否出现更多
    /* handleResizeHandler() {
          const self = this;
          let screenWidth = window.screenWidth || document.body.clientWidth;
          if (this.navigations.length > 10) {
              self.navigationstatus = true;
          }  else if( screenWidth < 1500 && this.navigations.length > 10){
              self.navigationstatus = true;
          }  else {
              self.navigationstatus = false;
          }
      } */
  }
};